module.exports = __webpack_public_path__ + "img/download_code.948cfb6a.png";